import HistoryIcon from '@mui/icons-material/History';
import React from 'react';

export const AuditIcon = ({
	bgColor = '#F3D7C4',
	width = 24,
	height = 24,
	...props
}) => {
	const { color } = props;

	return (
		<HistoryIcon
			{...props}
			sx={{
				backgroundColor: bgColor,
				width,
				height,
				borderRadius: 2,
				padding: bgColor === 'transparent' ? 0 : 0.5,
				boxSizing: 'border-box',
				color: color ?? '#fff',
			}}
		/>
	);
};
